import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { NewsCard } from "@/components/news/NewsCard";

export const NewsTeaser = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/news", { params: { limit: 3 } })
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-24 lg:py-32 border-t border-[#E3E2DA]" data-testid="news-teaser-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <Reveal>
            <Eyebrow>Nyheter</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-[-0.03em] mt-4">Senaste från Redoc</h2>
          </Reveal>
          <Link to="/nyheter" data-testid="news-teaser-all-link" className="group inline-flex items-center gap-2 font-semibold text-[#0B14A0]">
            Alla nyheter <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.slice(0, 3).map((n, i) => (
            <Reveal key={n.id} delay={i * 0.08} className="h-full"><NewsCard item={n} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
